export const LANDSCAPE_LARGE = {
  width: 1280,
  height: 720
};

export const LANDSCAPE_MEDIUM = {
  width: 480,
  height: 270
};

export const LANDSCAPE_SMALL = {
  width: 295,
  height: 166
};

export const REDUCED_LARGE = {
  width: 720,
  height: 540
};

export const REDUCED_MEDIUM = {
  width: 480,
  height: 360
};

export const PORTRAIT_MEDIUM = {
  width: 265,
  height: 466
};

export const SQUARED_MEDIUM = {
  width: 480,
  height: 480
};

export const SQUARED_SMALL = {
  width: 170,
  height: 170
};

export const XSQUARED_SMALL = {
  width: 110,
  height: 110
};

export const XXSQUARED_SMALL = {
  width: 80,
  height: 80
};

export const PANORAMA_LARGE = {
  width: 1280,
  height: 400
};

export const PANORAMA_MEDIUM = {
  width: 720,
  height: 225
};

export const PANORAMA_SMALL_MEDIUM = {
  width: 500,
  height: 188
};

export const PANORAMA_SMALL = {
  width: 480,
  height: 150
};

export const AVATAR_SMALL = {
  width: 36,
  height: 36
};

export const AVATAR_MEDIUM = {
  width: 72,
  height: 72
};

export const AVATAR_BIG = {
  width: 118,
  height: 118
};

export const getCrop = ({ path, format = 'jpg' }) => `${path}default.${format}`;
export const getCropWithPath = ({ idUser }) =>
  `/intranetemployee/v1/api/public/hcm/hcm-avatar?userId=${idUser}`;

export const getDemoCrop = () =>
  `http://intranetpre.atresmedia.com/images/images01/2018/02/14/5a842c0f8969d80001db8cfe/default.png?1518617111370`;
